<div class="conselling-form">
    <div class="icn">
        <i class="bi bi-x-lg" (click)="close()" ></i>
    </div>
    <div class="head">
        <h4 class="title" style="margin-bottom: 25px;">Course Enquiry </h4>
    </div>
    <form >
      <div class="row">
        <div class="col-md-12">
          <mat-form-field  class="mat_form_filed">
            <input matInput placeholder="Name" >
          </mat-form-field>
        </div>

        <div class="col-md-12">
          <mat-form-field  class="mat_form_filed">
            <input matInput placeholder="Mobile Number" >
          </mat-form-field>
        </div>
    
        
        <div class="col-md-12">
            <mat-form-field  class="mat_form_filed">
            
              <input matInput placeholder="Email" >
            </mat-form-field>
        </div>
        <div class="col-md-12 col-12 ">
            <mat-form-field  class="mat_form_filed">
           
              <mat-select placeholder="Target Year" >
                <mat-option value="2024">2024</mat-option>
                <mat-option value="2025">2025</mat-option>
                <mat-option value="2026">2026</mat-option>
                <mat-option value="2027">2027</mat-option>
              </mat-select>
            </mat-form-field>
        </div>
     
    
        <div class="col-md-12 col-12 ">
                    <button mat-button >Send Message</button>
        </div>
      </div>
    </form>
 

</div>